import { motion } from 'framer-motion'

import { memo } from 'react'
import { useLoading } from '~store/loading'

const LoadingScreenProvider = memo(() => {
  const isLoading = useLoading()

  return isLoading ? (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-toast">
      <div className="flex flex-gap-x-2">
        {[0, 1, 2].map(index => (
          <motion.div
            key={index}
            className="w-3 h-3 bg-white rounded-full"
            animate={{
              y: ['0%', '-100%', '0%'],
            }}
            transition={{
              duration: 0.8,
              repeat: Infinity,
              delay: index * 0.2,
              ease: 'easeInOut',
            }}
          />
        ))}
      </div>
    </div>
  ) : null
})

LoadingScreenProvider.displayName = 'LoadingScreen'
export default LoadingScreenProvider
